import { render, staticRenderFns } from "./TargetCompanyModal.vue?vue&type=template&id=612df1ac"
import script from "./TargetCompanyModal.vue?vue&type=script&lang=js"
export * from "./TargetCompanyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports